module.exports = __webpack_public_path__ + "img/notification.380ccd14.svg";